import React, { useState, useEffect } from "react";
import { render } from "react-dom";
import { BrowserRouter, Route, Switch, Redirect, Link, useLocation } from "react-router-dom";
import ReactGA from 'react-ga';

import { Alert } from "reactstrap";

import Index from "views/Index";
import Overview from "views/Discover/Overview";
import Features from "views/Discover/Features";
import Pricing from "views/Discover/Pricing";
import About from "views/Company/About";
import Jobs from "views/Company/Jobs";
import Contact from "views/Company/Contact/Contact";
import Sales from "views/Company/Contact/Sales";

import axios from 'axios';

AXIOS = axios.create();

ReactGA.initialize("UA-165386068-1");

function usePageViews() {
    let location = useLocation();

    useEffect(() => {
        ReactGA.pageview(location.pathname);
    }, [location]);
}

function loadAgileApi() {
    const agileJS = document.getElementById('_agile_min_js');

    agileJS.onload = setTimeout(() => {
        _agile.set_account('e10cscrq46ert0bnlslb50ucu9', 'clubapps', false);
        _agile.track_page_view();
        _agile_execute_web_rules();
    }, 500); 
}

function App() {

    const [ alertOpen, setAlertOpen ] = useState(true);
    
    usePageViews();

    loadAgileApi();

    const toggleAlert = () => setAlertOpen(!alertOpen);

    return (
        <>
            <Alert color="primary" fade={false} isOpen={alertOpen} toggle={toggleAlert}>
                <span className="alert-inner--icon">
                    <i className="ni ni-bell-55" />
                </span>{" "}
                <span className="alert-inner--text">
                    <strong>Hey!</strong> Club Apps is currently in Beta. Please <Link className="text-white font-weight-bold" to="/contact/sales">contact sales</Link> to join our Beta release.
                </span>
            </Alert>
            <Switch>
                <Route 
                    path="/" 
                    exact 
                    render={props => <Index {...props} />}
                />
                <Route 
                    path="/overview" 
                    exact 
                    render={props => <Overview {...props} />}
                />
                <Route 
                    path="/features" 
                    exact 
                    render={props => <Features {...props} />}
                />
                <Route 
                    path="/pricing" 
                    exact 
                    render={props => <Pricing {...props} />}
                />
                <Route 
                    path="/about-us" 
                    exact 
                    render={props => <About {...props} />}
                />
                <Route 
                    path="/jobs" 
                    exact 
                    render={props => <Jobs {...props} />}
                />
                <Route 
                    path="/contact" 
                    exact 
                    render={props => <Contact {...props} />}
                />
                <Route 
                    path="/contact/sales" 
                    exact 
                    render={props => <Sales {...props} />}
                />
                <Redirect to="/" />
            </Switch>
        </>
    )
}

render (
    <BrowserRouter>
        <App/ >
    </BrowserRouter>,
    document.getElementById('app')
)
